import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import ArrayIcon from '@/assets/array.svg?react';

import css from './index.module.less';

export function HeroSection() {
  const handleLearnMore = () => {
    const baseName = import.meta.env.VITE_BASE_NAME || '/';
    const baseUrl = baseName === '/' ? '' : baseName;
    window.open(`${baseUrl}/cli-docs`, '_blank');
  };

  const { t } = useTranslation();

  return (
    <div className={clsx(css['hero-container'])}>
      <h1 className={clsx(css['hero-title'])}>
        CodeFlicker
        <span className={clsx(css['cli-highlight'])}> CLI</span>
      </h1>
      <div className={clsx(css['hero-description'])}>
        {t('cli.inner.hero.description')}
        <span className={clsx(css['hero-link'])} onClick={handleLearnMore}>
          {t('cli.inner.hero.learnMore')}
          <ArrayIcon />
        </span>
      </div>
    </div>
  );
}
